import styled from "styled-components";


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px 50px 0px;
  box-sizing: border-box;
  position: relative;
`
